import React, { useState, useEffect, useMemo } from "react";
import { IonIcon } from "@ionic/react";
import { closeOutline } from "ionicons/icons";

interface Props {
  isOpen: boolean;
  children: string | JSX.Element | JSX.Element[];
  onClose: () => void;
  /** When true, curtain scrolls and scrollbar appears at viewport edge. When false, modal is centered and content scrolls inside. */
  scrollAtViewport?: boolean;
}

export const ModalContainer: React.FC<Props> = ({
  isOpen,
  children,
  onClose,
  scrollAtViewport = false,
}) => {
  const curtainStyle = scrollAtViewport
    ? defaultStyles.modalCurtainScrollAtViewport
    : defaultStyles.modalCurtain;
  const boxStyle = scrollAtViewport
    ? defaultStyles.modalBox
    : defaultStyles.modalBoxWithInnerScroll;

  return (
    <div
      style={{
        ...curtainStyle,
        display: isOpen ? ("flex" as "flex") : ("none" as "none"),
      }}
    >
      <div style={boxStyle}>
        <div
          style={defaultStyles.closeButtonContainer}
          onClick={() => {
            onClose();
          }}
        >
          <IonIcon
            icon={closeOutline}
            style={{ fontSize: "18px" }}
            aria-hidden="true"
          />
        </div>
        {scrollAtViewport ? (
          children
        ) : (
          <div style={defaultStyles.modalContent}>{children}</div>
        )}
      </div>
    </div>
  );
};

const defaultStyles = {
  modalCurtain: {
    position: "fixed" as "fixed",
    top: "0px",
    bottom: "0px",
    left: "0px",
    right: "0px",
    backgroundColor: "rgba(0.4,0.4,0.4,0.4)",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 10000,
  },
  modalCurtainScrollAtViewport: {
    position: "fixed" as "fixed",
    top: "0px",
    bottom: "0px",
    left: "0px",
    right: "0px",
    backgroundColor: "rgba(0.4,0.4,0.4,0.4)",
    alignItems: "flex-start",
    justifyContent: "center",
    overflowY: "auto" as "auto",
    padding: "24px",
    zIndex: 10000,
  },
  modalBox: {
    padding: "20px",
    borderRadius: "6px",
    minWidth: "100px",
    backgroundColor: "#fff",
    boxShadow: "2px 2px 6px rgba(0.4,0.4,0.4,0.4)",
    position: "relative" as "relative",
  },
  modalBoxWithInnerScroll: {
    padding: "20px",
    borderRadius: "6px",
    minWidth: "100px",
    maxHeight: "90vh",
    backgroundColor: "#fff",
    boxShadow: "2px 2px 6px rgba(0.4,0.4,0.4,0.4)",
    position: "relative" as "relative",
    display: "flex",
    flexDirection: "column" as "column",
    overflow: "hidden",
  },
  modalContent: {
    overflowY: "auto" as "auto",
    minHeight: 0,
    paddingRight: "4px",
  },
  closeButtonContainer: {
    position: "absolute" as "absolute",
    top: "10px",
    right: "10px",
    cursor: "pointer",
  },
};

export default ModalContainer;
